// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__YwX8Y","modalHeader":"Modal_modalHeader__hGKN2","modalHeaderNotification":"Modal_modalHeaderNotification__n0QHG"};